import { useGameStore } from '@/store/gameStore';
import { audioEngine } from './AudioEngine';

export function initAudioSubscription(): void {
  useGameStore.subscribe((state, prevState) => {
    // Detect new strike result
    if (state.lastStrikeResult && state.lastStrikeResult !== prevState.lastStrikeResult) {
      const result = state.lastStrikeResult;

      // Play strike sound
      const struckNode = state.board?.nodes.find((n) => n.id === result.struckNodeId);
      if (struckNode) {
        audioEngine.playStrike(struckNode.frequency);
      }

      // Schedule transmutation sounds with ring-based delays
      for (const t of result.transmutations) {
        const delayMs = t.ring * 200; // Ring 1: 200ms, Ring 2: 400ms, Ring 3: 600ms
        audioEngine.playTransmutation(t.oldFrequency, t.newFrequency, delayMs);
      }
    }

    // Detect resonance achieved
    if (state.isComplete && !prevState.isComplete && state.board) {
      const frequencies = state.board.nodes.map((n) => n.frequency);
      // Delay slightly so it plays after the last transmutation
      setTimeout(() => {
        audioEngine.playResonance(frequencies);
      }, 1000);
    }
  });
}
